module.exports = __webpack_public_path__ + "static/media/envelope.1e100c35.svg";